import React from 'react';

import theme from '@/styles/theme';

interface Props {
  size?: number;
  fill?: string;
}
const IconLocationPinMono = ({ size = 14, fill = theme.color.blue500 }: Props) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 14 14' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.00042 7.43283C6.79 7.43687 6.58088 7.39892 6.3853 7.32118C6.18972 7.24345 6.0116 7.1275 5.86136 6.98012C5.71112 6.83274 5.59178 6.65688 5.5103 6.46282C5.42883 6.26877 5.38687 6.06042 5.38687 5.84996C5.38687 5.6395 5.42883 5.43115 5.5103 5.2371C5.59178 5.04304 5.71112 4.86718 5.86136 4.7198C6.0116 4.57241 6.18972 4.45647 6.3853 4.37873C6.58088 4.301 6.79 4.26304 7.00042 4.26708C7.41497 4.27504 7.80984 4.44531 8.1002 4.74129C8.39055 5.03727 8.5532 5.43534 8.5532 5.84996C8.5532 6.26458 8.39055 6.66265 8.1002 6.95863C7.80984 7.25461 7.41497 7.42488 7.00042 7.43283ZM5.76142 0.604918C3.27059 1.16083 1.52409 3.50525 1.62209 6.05558C1.69909 8.05875 2.92817 9.85075 6.58509 13.3665C6.81609 13.5882 7.18592 13.5893 7.41751 13.3671C11.1998 9.73117 12.3852 7.93917 12.3852 5.84967C12.3852 2.47217 9.27426 -0.179082 5.76142 0.605501'
        fill={fill}
      />
    </svg>
  );
};

export default IconLocationPinMono;
